import { render } from "./produtos.vue?vue&type=template&id=2dfa4594"
import script from "./produtos.vue?vue&type=script&lang=js"
export * from "./produtos.vue?vue&type=script&lang=js"

import "./produtos.vue?vue&type=style&index=0&id=2dfa4594&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__